import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';

import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import VisionSection from './components/VisionSection';
import Icon from '../../components/AppIcon';
import Image from '../../components/AppImage';

const About = () => {
  const navigate = useNavigate();
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const [activeCircle, setActiveCircle] = useState('all');

  const circles = [
    {
      id: 'literature',
      name: 'دائرة الأدب',
      icon: 'BookOpen',
      color: '#8B6914',
      subtext: 'أدب عربي - أدب مقارن',
      hasChildren: true
    },
    {
      id: 'soul',
      name: 'دائرة النفس',
      icon: 'Heart',
      color: '#7D8471',
      subtext: 'رحلة في أعماق الذات'
    },
    {
      id: 'visuals',
      name: 'دائرة العين',
      icon: 'Eye',
      color: '#D4AF37',
      subtext: 'لأن الرؤية تسبق كل شيء.'
    },
    {
      id: 'sound',
      name: 'دائرة الصوت',
      icon: 'Music',
      color: '#8B7355',
      subtext: 'قسمٌ معني بالصوتيات، كالموسيقى والغناء'
    },
    {
      id: 'philosophy',
      name: 'دائرة العقل',
      icon: 'Brain',
      color: '#6B5B47',
      subtext: 'قسمٌ معنيٌ بالفلسفة. لأن الفلسفة هي الحكمة...'
    },
    {
      id: 'heritage',
      name: 'دائرة التراث',
      icon: 'Landmark',
      color: '#8B4513',
      subtext: 'تأملات لأصحابها'
    },
    {
      id: 'arts',
      name: 'دائرة الفنون',
      icon: 'Palette',
      color: '#A0826D',
      subtext: 'قسمٌ معنيٌ بالفنون البصرية والتشكيلية'
    },
    {
      id: 'language',
      name: 'دائرة اللسان',
      icon: 'MessageSquare',
      color: '#6B8E23',
      subtext: 'قسمٌ معنيٌ باللغة العربية وتراكيبها.'
    },
    {
      id: 'reflections',
      name: 'دائرة الرحلة',
      icon: 'Sparkles',
      color: '#9B7653',
      subtext: 'تأملات شخصية وخواطر روحية'
    },
    {
      id: 'sufism',
      name: 'دائرة الدائرة',
      icon: 'Star',
      color: '#5A5A5A',
      subtext: 'افتح عينك؛ فما ثم إلا وجودٌ مستمر...'
    }];

  const handleFilterChange = (circleId, e) => {
    if (e) {
      e?.preventDefault();
    }
    if (activeCircle === circleId) {
      setActiveCircle('all');
    } else {
      setActiveCircle(circleId);
    }
    navigate('/');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      {/* Mobile Header Bar */}
      <div className="flex lg:hidden fixed top-0 left-0 right-0 h-16 bg-[#F9F7F2]/95 backdrop-blur-sm z-50 px-4 justify-between items-center pt-20">
        <div className="flex items-center gap-2">
          <Image
            src="/assets/images/header_logo-1769143036795.png"
            alt="شعار دوائر"
            className="h-8 object-contain"
            style={{ filter: 'brightness(0) saturate(100%) invert(61%) sepia(32%) saturate(567%) hue-rotate(358deg) brightness(92%) contrast(87%)' }} />
          <div className="flex flex-col justify-center">
            <h1
              className="font-bold text-[32px]"
              style={{ fontFamily: 'Aref Ruqaa, serif', color: '#C5A059' }}>
              دوائر
            </h1>
            <p
              className="whitespace-nowrap text-xs"
              style={{ color: '#5A5A5A' }}>
              نغرّد داخل السِرب؛ آملين أن تنبُتَ للجميع أجنحة.
            </p>
          </div>
        </div>
        <button
          onClick={() => setIsMobileDrawerOpen(true)}
          className="flex items-center justify-center w-10 h-10"
          aria-label="القائمة">
          <Icon name="Menu" size={24} color="#C5A059" />
        </button>
      </div>

      {/* Mobile Drawer Overlay */}
      {isMobileDrawerOpen &&
        <div
          className="lg:hidden fixed inset-0 bg-black/50 z-50"
          onClick={() => setIsMobileDrawerOpen(false)}>
          <div
            className="absolute top-0 right-0 bottom-0 w-80 bg-[#F9F7F2] shadow-2xl overflow-y-auto scrollbar-hide animate-slideInRight"
            onClick={(e) => e?.stopPropagation()}>
            <div className="flex justify-end p-4">
              <button
                onClick={() => setIsMobileDrawerOpen(false)}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-black/5"
                aria-label="إغلاق">
                <Icon name="X" size={24} color="#5A5A5A" />
              </button>
            </div>

            <div className="px-6 py-4 space-y-4 text-center">
              <a href="/" className="block text-xl font-medium text-[#2C2B29] py-3 text-right" style={{ fontFamily: 'Amiri, serif' }}>الرئيسية</a>
              <a href="/about-dawaaer" className="block text-xl font-medium text-[#2C2B29] py-3 text-right" style={{ fontFamily: 'Amiri, serif' }}>عن دوائر</a>
              <a href="/about" className="block text-xl font-medium text-[#2C2B29] py-3 text-right" style={{ fontFamily: 'Amiri, serif' }}>من نحن؟</a>
              <a href="/policy" className="block text-xl font-medium text-[#2C2B29] py-3 text-right" style={{ fontFamily: 'Amiri, serif' }}>سياستنا</a>
            </div>

            <div className="mx-6 my-4 border-t border-[#C5A059]/30" />

            <div className="px-6 py-4">
              <h3 className="text-lg font-bold mb-4 text-right" style={{ fontFamily: 'Aref Ruqaa, serif', color: '#2C2B29' }}>
                دوائر
              </h3>
              <div className="space-y-2">
                {circles?.map((circle) =>
                  <button
                    key={circle?.id}
                    onClick={(e) => {
                      handleFilterChange(circle?.id, e);
                      setIsMobileDrawerOpen(false);
                    }}
                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all min-h-[44px] ${activeCircle === circle?.id ?
                      'bg-[#C5A059]/15 text-[#C5A059]' :
                      'text-[#2C2B29] hover:bg-[#C5A059]/10'}`
                    }
                    style={{ fontFamily: 'Amiri, serif' }}>
                    <div className="flex items-center justify-center w-10 h-10 flex-shrink-0">
                      {circle?.id === 'sufism' ?
                        <img
                          src="/assets/images/Screenshot_2026-01-22_223436-removebg-preview-1769116472162.png"
                          alt="دائرة الدائرة"
                          className="w-5 h-5 object-contain opacity-90"
                          style={{
                            filter: activeCircle === circle?.id ?
                              'grayscale(0%) contrast(125%)' :
                              'grayscale(100%) contrast(125%)'
                          }} /> :
                        circle?.id === 'soul' ?
                          <img
                            src="/assets/images/Screenshot_2026-01-22_223930-removebg-preview_1_-1769115911481.png"
                            alt="دائرة النفس"
                            className="w-7 h-7 object-contain opacity-100"
                            style={{
                              filter: activeCircle === circle?.id ?
                                'grayscale(0%) contrast(125%)' :
                                'grayscale(100%) contrast(125%)'
                            }} /> :
                          circle?.id === 'sound' ?
                            <img
                              src="/assets/images/vecteezy_black-sound-wave-icon-with-simple-and-modern-design_47445215-1769116873745.png"
                              alt="دائرة الصوت"
                              className="w-10 h-10 object-contain opacity-100"
                              style={{
                                filter: activeCircle === circle?.id ?
                                  'grayscale(0%) contrast(125%)' :
                                  'grayscale(100%) contrast(125%)'
                              }} /> :
                            circle?.id === 'reflections' ?
                              <img
                                src="/assets/images/Screenshot_2026-01-22_232822-removebg-preview-1769117314572.png"
                                alt="دائرة الرحلة"
                                className="w-6 h-6 object-contain opacity-90"
                                style={{
                                  filter: activeCircle === circle?.id ?
                                    'grayscale(0%) contrast(125%)' :
                                    'grayscale(100%) contrast(125%)'
                                }} /> :
                              circle?.id === 'language' ?
                                <img
                                  src="/assets/images/Screenshot_2026-01-22_233414-removebg-preview-1769117612785.png"
                                  alt="دائرة اللسان"
                                  className="w-7 h-7 object-contain opacity-100"
                                  style={{
                                    filter: activeCircle === circle?.id ?
                                      'grayscale(0%) contrast(125%)' :
                                      'grayscale(100%) contrast(125%)'
                                  }} /> :
                                circle?.id === 'heritage' ?
                                  <img
                                    src="/assets/images/Screenshot_2026-01-23_003258-removebg-preview-1769121221939.png"
                                    alt="دائرة التراث"
                                    className="w-9 h-9 object-contain opacity-100"
                                    style={{
                                      filter: activeCircle === circle?.id ?
                                        'grayscale(0%) contrast(125%)' :
                                        'grayscale(100%) contrast(125%)'
                                    }} /> :
                                  circle?.id === 'arts' ?
                                    <img
                                      src="/assets/images/images-removebg-preview-1769118454586.png"
                                      alt="دائرة الفنون"
                                      className="w-7 h-7 object-contain opacity-100"
                                      style={{
                                        filter: activeCircle === circle?.id ?
                                          'grayscale(0%) contrast(125%)' :
                                          'grayscale(100%) contrast(125%)'
                                      }} /> :

                                    <Icon
                                      name={circle?.icon}
                                      size={20}
                                      color={activeCircle === circle?.id ? '#C5A059' : circle?.color}
                                      style={{
                                        filter: activeCircle === circle?.id ?
                                          'grayscale(0%) contrast(125%) opacity(0.9)' :
                                          'grayscale(100%) contrast(125%) opacity(0.9)'
                                      }} />
                      }
                    </div>
                    <span className="flex-1 text-right text-base">{circle?.name}</span>
                  </button>
                )}
              </div>
            </div>

            {/* Discussion Circles Button */}
            <div className="px-6 py-4">
              <button
                onClick={() => {
                  navigate('/discussions-feed');
                  setIsMobileDrawerOpen(false);
                }}
                className="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all min-h-[44px] bg-[#C5A059]/10 text-[#C5A059] hover:bg-[#C5A059]/20"
                style={{ fontFamily: 'Amiri, serif' }}>
                <div className="flex items-center justify-center w-10 h-10 flex-shrink-0">
                  <Icon name="Users" size={20} color="#C5A059" />
                </div>
                <span className="flex-1 text-right text-base">حلقات نقاشية</span>
              </button>
            </div>

            <div className="px-6 py-6 mt-auto">
              <button
                onClick={() => navigate('/creator-studio')}
                className="w-full bg-[#C5A059] text-white py-4 rounded-full font-medium text-lg min-h-[44px]"
                style={{ fontFamily: 'Amiri, serif' }}>
                اترك أثراً
              </button>
            </div>
          </div>
        </div>
      }
      <main className="pt-16 lg:pt-20">
        <HeroSection />
        <MissionSection />
        <VisionSection />
      </main>
      {/* Footer */}
      <footer className="bg-card border-t border-border py-8 md:py-10 lg:py-12">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-sm md:text-base text-muted-foreground">
              © {new Date()?.getFullYear()} <span className="font-bold text-[var(--color-foreground)]">دوائر</span>. جميع حقوق النشر محفوظة لأصحابها.
            </p>
          </div>
        </div>
      </footer>
    </div>);

};

export default About;